// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Button } from "metabase/common/components/Button";

export const IconButton = styled(Button)`
  margin-left: 0.5rem;
`;
